export const REGEX_ACCOUNT_NUMBER = /^\d{7,8}$/;
export const REGEX_PHONE_NUMBER = /^\+?[\d-]+$/;
export const REGEX_PHONE_NUMBER_FORMATTED = /^[0-9０-９]{10,11}$/;
export const REGEX_EMAIL = /^[a-zA-Z0-9!#&~‘$*+/=?^`{|}_.%'[\]\\+-]{1,64}@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
export const REGEX_URL = /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w.-]+)+[\w\-._~:/?#[\]@!$&'()*+,;=.]+$/;
export const REGEX_HAFTWIDTH = /^[ｧ-ﾝﾞﾟ ]|[a-zA-Z ]/;
export const REGEX_PASSWORD = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])[A-Za-z\d[$&+,:;=?@#|'<>.^*()%!-\]{}'"/?_]{8,30}$/;
export const REGEX_PASSWORD_CMS = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{8,}$/;
export const REGEX_USERNAME = /^[a-zA-Zａ-ｚＡ-Ｚ0-9０-９ぁ-んァ-ンー一-龯$&+,:;=?@#|'<>.^*()%!{}'"/?_]{1,}$/;
export const REGEX_NUMBER = /\B(?=(\d{3})+(?!\d))/g;
export const REGEX_IMAGE = /\.(heic|jpe?g|jfif|png)$/i;
export const REGEX_URL_NAME = /^([a-zA-Z0-9]|-|_)+$/;
export const REGEX_HTML_TAG = /<[^>]+>/g;
export const REGEX_NUMBER_HAFLWIDTH = /^[0-9]+$/;
export const REGEX_IMG_TAG = /<img([\w\W]+?)\/>/;
export const REGEX_IFRAME_TAG = /<iframe([\w\W]+?)>/;
export const REGEX_USERNAME_STAFF = /^[ぁ-んァ-ンA-Za-z\u3000\u3400-\u4DBF\u4E00-\u9FFF]{1,}$/;
export const REGEX_NUMBER_AND_DOT = /^[0-9]*\.?[0-9]*$/;
export const MAX_IMAGE_SIZE = 10 * 1024 * 1024;
export const REGEX_SPECIAL_STRING = /[`!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~]/;
export const katakana = /^[ァ-ンーｧ-ﾝﾞﾟパヂヴピプペポガギグゲゴザジズゼゾダジデドバビブベボ 　]{1,}$/g;
export const katakanaAccountName =
  /^[a-zA-Zａ-ｚＡ-Ｚ0-9ァ-ンーｧ-ﾝﾞﾟパヂヴピｦプペポガギグゲゴザジズゼゾダジデドバビブベ￥ボ 　（）")(-/.,｢｣""]{1,}$/g;
export const NumberOfJP = /^[0-9０-９ ]+$/;
export const NumberPhone = /^[0-9-０-９ ]+$/;
export const isNumberOfJP = /[^0-9０-９]+/g;
export const isNumberHaf = /[^0-9]+/g;
export const katakanaAndNumber = /^[ァ-ンーｧ-ﾝﾞﾟ0-9]{1,}$/g;
export const JAPANESE_CHARACTER = /[\u3000-\u303f\u3040-\u309f\u30a0-\u30ff\uff00-\uff9f\u4e00-\u9faf\u3400-\u4dbf]/g;
export const REGEX_SETTING_SALARY = /^(0?[1-9]|[12][0-9]|3[01])$/;
